// @flow

import PropTypes from 'prop-types';

import React, { Component } from 'react';

// -- entities
import { OrderProductOption, OrderProductOptionValue } from 'PMT/entities/order';
import { RestaurantMenu } from 'PMT/entities/menu';

// -- views
import OrderProductOptionValueView from './OrderProductOptionValueView';

export default class OrderProductOptionView extends Component {

  static propTypes = {
    orderProductOption: PropTypes.objectOf(OrderProductOption).isRequired,

    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired
  };

  get orderProductOption(): OrderProductOption {
    return this.props.orderProductOption;
  }


  //
  // Renderers
  //

  renderName() {
    return (
      <div className="order_product_option_view__name">
        {this.orderProductOption.name}
      </div>
    );
  }
  renderValues() {
    return (
      <div className="order_product_option_view__values">
        {this.orderProductOption.values.map((orderProductOptionValue: OrderProductOptionValue, index) => {
          return (
            <OrderProductOptionValueView
              key={`${orderProductOptionValue.id}_${index}`}
              orderProductOptionValue={orderProductOptionValue}
              orderProductOption={this.orderProductOption}
              quantity={0}
            />
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="order_product_option_view">
        {/* {this.renderName()} */}
        {this.renderValues()}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/components/order/orderDetailModal/OrderProductOptionView.js